const IRREGULAR_ALL_LABELS: Record<string, string> = {
  Country: "All Countries",
  Status: "All Status",
};

/**
 * Builds the "All …" option label shown at the top of a filter drawer section.
 *
 * @param title Section title, e.g. "Crop" or "Fields".
 * @returns The pluralised label, e.g. "All Crops"; titles already ending in "s" are kept as-is.
 */
export const getAllLabel = (title: string): string => {
  const irregular = IRREGULAR_ALL_LABELS[title];
  if (irregular) return irregular;
  return title.endsWith("s") ? `All ${title}` : `All ${title}s`;
};
